module.exports = __webpack_public_path__ + "static/media/image-not-found.f44e0d7b.jpg";